import React, { useState } from "react";
import {
    Drawer,
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Typography,
} from "@mui/material";
import { Menu, Home, PhotoLibrary, Info, Email } from "@mui/icons-material";

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setIsOpen(open);
    };

    const navItems = [
        { label: "Home", icon: <Home />, href: "#home" },
        { label: "Gallery", icon: <PhotoLibrary />, href: "#gallery" },
        { label: "About", icon: <Info />, href: "#about" },
        { label: "Contact", icon: <Email />, href: "#contact" },
    ];

    return (
        <Box>
            {/* Hamburger Menu */}
            <IconButton
                onClick={toggleDrawer(true)}
                sx={{ position: "fixed", top: 16, left: 16 }}
            >
                <Menu />
            </IconButton>

            {/* Sidebar Drawer */}
            <Drawer anchor="left" open={isOpen} onClose={toggleDrawer(false)}>
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <Typography
                        variant="h6"
                        sx={{ p: 2, borderBottom: "1px solid #ccc" }}
                    >
                        skbinfocus
                    </Typography>
                    <List>
                        {navItems.map((item) => (
                            <ListItem key={item.label} disablePadding>
                                <ListItemButton component="a" href={item.href}>
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.label} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
};

export default Sidebar;
